import BaseError from './BaseError';

class RightsError extends BaseError {
  constructor(message: string) {
    super('RightsError', message);
  }
}

export default RightsError;
